exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".selected td[data-v-f9640810]{background-color:#e8f1f6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-master/~/css-loader?minimize!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9640810","scoped":true,"hasInlineConfig":false}!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/selector.js?type=styles&index=0!./modules/repositories/components/tags-table-row.vue
// module id = 72
// module chunks = 0